import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadersComponent } from './loaders.component';



@NgModule({
  declarations: [ LoadersComponent ],
  imports: [
    CommonModule
  ],
  exports: [
    LoadersComponent
  ]
})
export class LoadersModule { }
